/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const BlankEnum = zod.enum(['']);

export type BlankEnum = zod.input<typeof BlankEnum>;
export type BlankEnumOutput = zod.output<typeof BlankEnum>;
